<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container"
               @toggleClick="toggleSideBar"/>
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!settingsStore.topNav"/>
    <TopNav id="topmenu-container" v-if="settingsStore.topNav"/>

    <div class="right-menu">
      <template v-if="appStore.device !== 'mobile'">
        <header-search id="header-search" class="right-menu-item"/>
        <!--        <el-tooltip content="操作文档" effect="dark" placement="bottom">-->
        <!--        </el-tooltip>-->
        <HelpDoc class="right-menu-item hover-effect"/>
        <el-tooltip content="最大化" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect"/>
        </el-tooltip>
        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect"/>
        </el-tooltip>
      </template>
      <ElDropdown v-if="loginList.length" class="test-login" @command="handleLoginType" trigger="hover">
        <ElButton icon="Lock"/>
        <template #dropdown>
          <ElDropdownMenu>
            <ElDropdownItem v-for="({remark,dictLabel}) in loginList" :key="dictLabel" :command="dictLabel">
              {{ remark }}【{{ dictLabel }}】
            </ElDropdownItem>
          </ElDropdownMenu>
        </template>
      </ElDropdown>
      <div class="avatar-container">
        <el-dropdown @command="handleCommand" class=" hover-effect" trigger="click">
          <div class="avatar-wrapper flex">
            <img :src="userStore.avatar" alt="" class="user-avatar"/>
            <div class="avatar-info flex-1 flex-col ta-l">
              <span class="nick-name"> {{ userStore.nickName }}</span>
              <div class="dept-name">{{ userStore?.userInfo?.dept?.deptName }}</div>
            </div>
            <el-icon>
              <caret-bottom/>
            </el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="setLayout" v-if="settingsStore.showSettings">
                <span>布局设置</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ElMessageBox} from 'element-plus'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'
import HelpDoc from '@/components/doc/HelpDoc'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import {checkPermi} from '@/utils/permission'
import {encrypt, decrypt} from '@/utils/jsencrypt'
import {getDicts} from '@/api/system/dict/data'
import {useRouter} from 'vue-router'

const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()


function toggleSideBar() {
  appStore.toggleSideBar()
}

function handleCommand(command) {
  switch (command) {
    case 'setLayout':
      setLayout()
      break
    case 'logout':
      logout()
      break
    default:
      break
  }
}

function logout() {
  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    userStore.logOut().then(() => {
      location.href = '/index'
    })
  }).catch(() => {
  })
}

const emits = defineEmits(['setLayout'])

function setLayout() {
  emits('setLayout')
}

const loginList = ref([])
const {proxy} = getCurrentInstance()
const router = useRouter()

const handleLoginType = async (val) => {
  const target = loginList.value.find(item => item.dictLabel === val)
  const loginForm = {
    username: target.dictLabel,
    password: target.dictValue
  }
  const encrypted = encrypt(loginForm.password)
  if (!encrypted) {
    throw new Error('密码加密失败')
  }
  // todo 加密密码
  console.log(encrypted)
  try {
    await userStore.login(loginForm)
    await router.push({path: '/index', query: {}})
    window.location.reload()
  } catch (err) {
    console.error(err)
  } finally {
    proxy.$modal.closeLoading()
  }
}

//   判断是否存在测试权限，是的话请求测试list
const getLoginList = async () => {
  const hasTestPermit = checkPermi(['test:account'])
  if (!hasTestPermit) return
  try {
    const res = await getDicts('test_account')
    loginList.value = res.data
    console.log(res.data)
  } catch (e) {
    console.error(e)
  }
}

onMounted(() => {
  getLoginList()
})
</script>

<style lang='scss'>
.navbar {
  --icon-width: 32px;
  --icon-size: 14px;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }


  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    //height: 100%;
    height: 50px;
    display: flex;
    padding: 8px 12px 8px 0;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      border: 1px solid #e4e7ee;
      line-height: var(--icon-width);
      width: var(--icon-width);
      text-align: center;
      border-radius: 10px;
      //padding: 0 8px;
      height: 100%;
      margin-right: 8px;
      font-size: var(--icon-size);
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          //background: rgba(0, 0, 0, 0.025);
        }
      }

      &:hover {
        box-shadow: var(--el-box-shadow-light);
        transform: translateY(-1px);
      }
    }

    .avatar-container {
      margin-right: 8px;
      border-radius: 20px;
      padding: 0 10px;
      text-align: center;
      cursor: pointer;
      border: 1px solid #e4e7ee;

      &:hover {
        transform: translateY(-1px);
        box-shadow: var(--el-box-shadow-light);
      }

      .avatar-info {
        margin-left: 10px;
        margin-right: 5px;

        .dept-name {
          color: #898989;
          font-size: 11px;
          line-height: 16px;
        }
      }

      .avatar-wrapper {
        display: flex;
        align-items: center;
        //margin-top: 5px;
        //position: relative;

        .nick-name {
          //display: inline-block;
          line-height: 16px;
          //padding-top: 2px;
          font-size: 13px;
          font-weight: 700;
        }

        .user-avatar {
          cursor: pointer;
          width: calc(var(--icon-width) - 4px);
          height: calc(var(--icon-width) - 4px);
          border-radius: 20px;
          object-fit: contain;
        }

        i {
          cursor: pointer;
          transform: translateY(-1px);
          font-size: 12px;
        }
      }
    }

    .test-login {
      margin-right: 8px;

      .el-button {
        height: 100%;
        padding-left: 8px;
        padding-right: 8px;
        border-radius: 10px;
      }
    }
  }
}
</style>
